import { render } from "./CouponStudioView.vue?vue&type=template&id=69ca8390&scoped=true"
import script from "./CouponStudioView.vue?vue&type=script&lang=js"
export * from "./CouponStudioView.vue?vue&type=script&lang=js"

import "./CouponStudioView.vue?vue&type=style&index=0&id=69ca8390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ca8390"]])

export default __exports__